export default __webpack_public_path__ + "static/media/service_1.42fa32d0.jpg";